// extracted by mini-css-extract-plugin
export var container = "Contact-module--container--8b26f";
export var divider = "Contact-module--divider--3ca77";
export var phones = "Contact-module--phones--fc093";
export var tabs = "Contact-module--tabs--a5de5";
export var workWithUs = "Contact-module--work-with-us--7d4dd";